var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCutFeatures = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: 1.054249,
    transform: "matrix(.89736973 0 0 1.0026331 4.43791 26.874653)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.011214-13.982422-.261719.964844c2.685682.732459 4.199824 1.711081 4.746599 2.492187.273387.390554.342698.7185638.314453.9804691-.02824.2619053-.152601.4779398-.373047.6542969-.440893.3527142-1.290393.4963022-2.240234.00781-.949841-.4884897-2.002523-1.614989-2.722657-3.775391l-.949218.316406c.779866 2.339598 1.977184 3.7130997 3.214843 4.34961s2.513159.5300983 3.322266-.1171875c.404554-.3236429.686448-.7951084.744141-1.3300781.05769-.5349697-.107372-1.1132104-.490235-1.6601564-.765725-1.093894-2.490875-2.115271-5.305192-2.882813z",
    fill: "#d00000",
    stroke: "#4a0000",
    strokeWidth: 0.4217
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.990234-20.78125c-1.380036.251563-3.030208 1.448876-4.588409 3.266776l.759766.652344c1.4418-1.682099 2.902594-2.733183 4.008331-2.934745s1.877016.148114 2.150391.527344c.136687.189615.176433.37291.117187.605469-.05925.232558-.242608.528548-.648437.833984-.811659.610873-2.495294 1.207676-5.310547 1.330078l.04297 1c2.934746-.127598 4.791572-.718295 5.86914-1.529297.538784-.405501.886292-.879042 1.015625-1.386719.129334-.507676.01594-1.035318-.27539-1.439453-.582657-.80827-1.760589-1.177344-3.140627-.925781z",
    fill: "#d00000",
    stroke: "#4a0000",
    strokeWidth: 0.4217
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#d5d5d5",
    stroke: "#717171",
    strokeLinejoin: "round",
    strokeWidth: 0.63255
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.5-17.5-2 1.5h-14c.535898 2 5.5 2.316989 9 2.274394h5.600269l3-2.274394z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13-12-15-10c6.187455 1.433592 11.182077 5.207953 16.5 8.5z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCutFeatures, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/cut_features.c6afeacf.svg";
export { ForwardRef as ReactComponent };